/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.0.2): index.umd.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

import Alert from '{{ URL::asset('src/alert'
import Button from '{{ URL::asset('src/button'
import Carousel from '{{ URL::asset('src/carousel'
import Collapse from '{{ URL::asset('src/collapse'
import Dropdown from '{{ URL::asset('src/dropdown'
import Modal from '{{ URL::asset('src/modal'
import Offcanvas from '{{ URL::asset('src/offcanvas'
import Popover from '{{ URL::asset('src/popover'
import ScrollSpy from '{{ URL::asset('src/scrollspy'
import Tab from '{{ URL::asset('src/tab'
import Toast from '{{ URL::asset('src/toast'
import Tooltip from '{{ URL::asset('src/tooltip'

export default {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  Offcanvas,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip
}
